import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDataModelState from './dataModels';

const handlers = {
  ...updateDataModelState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
